import { Outlet } from "react-router-dom";
import PageState from "../components/PageState";
import Notification from "../components/notification/Notification";

function QuickStartLayout() {
  return (
    <>
      <PageState />
      <main>
        <div id="content">
          <Outlet />
        </div>
        <Notification />
      </main>
    </>
  );
}

export default QuickStartLayout;
